import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withIcon = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-colors duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#FAF8F5]';
  const variants = {
    primary: 'bg-[#D4735E] text-white hover:bg-[#B55B46] focus:ring-[#D4735E] shadow-lg shadow-[#D4735E]/20',
    secondary: 'bg-[#2D2D2D] text-white hover:bg-black focus:ring-[#2D2D2D]',
    outline: 'border-2 border-[#D4735E] text-[#D4735E] hover:bg-[#D4735E]/5 focus:ring-[#D4735E]'
  };
  const classes = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-133">
        {children}
        {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-134" />}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-135">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-136" />}
    </motion.button>;
}